import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const ForgotPasswordButton = ({ onClick }) => {
    const { t } = useTranslation('customer');
    return (
        <div data-forgot-password className="m2g-form-element-group">
            <button
                className="m2g-customer-forgot-password-button m2g-button m2g-form-element--full-width"
                onClick={onClick}
                type="button"
            >
                {t('forgot_password')}
            </button>
        </div>
    );
};

ForgotPasswordButton.propTypes = {
    onClick: PropTypes.func,
};

ForgotPasswordButton.defaultProps = {
    onClick: null,
};

export default ForgotPasswordButton;
